import { Injectable } from "@angular/core";
import { DataService } from "../data.service";
import { LaboratoryAppointmentQuestion } from "src/app/model/laboratory-appointment-question/laboratory-appointment-question";

@Injectable({
  providedIn: "root",
})
export class LaboratoryAppointmentQuestionService {
  constructor(private dataService: DataService) {}

  private readonly endPoint: string = "/laboratoryAppointmentQuestion";

  async getByProcedureRegion(
    procedureRegionIds: number[],
    encounterCode: string | null = null,
  ): Promise<LaboratoryAppointmentQuestion[]> {
    const params = { procedureRegionIds, encounterCode };

    return await this.dataService
      .post<
        LaboratoryAppointmentQuestion[]
      >(`${this.endPoint}/GetByProcedureRegion`, params)
      .toPromise();
  }

  async getByAppointment(
    appointmentId: number,
  ): Promise<LaboratoryAppointmentQuestion[]> {
    const params = { appointmentId };

    return await this.dataService
      .get<
        LaboratoryAppointmentQuestion[]
      >(`${this.endPoint}/GetByAppointment`, params)
      .toPromise();
  }

  async update(questions: LaboratoryAppointmentQuestion[]): Promise<void> {
    const params = {
      Questions: questions,
      EncounterCode: questions.length > 0 ? questions[0].EncounterCode : null,
    };

    await this.dataService.post(`${this.endPoint}/Update`, params).toPromise();
  }
}
